export type AvatarState = 'boot' | 'idle' | 'attention' | 'listening' | 'thinking' | 'speaking' | 'error';
export const stateLabels: Record<AvatarState, string> = { boot: 'Собирается', idle: 'Ожидание', attention: 'Внимание', listening: 'Слушает', thinking: 'Обдумывает', speaking: 'Говорит', error: 'Ошибка' };
export class StateMachine extends EventTarget {
    current: AvatarState = 'boot';
    set(state: AvatarState) { if (!(state in stateLabels))
        throw Error('Неизвестное состояние'); if (state === this.current)
        return; const previous = this.current; this.current = state; this.dispatchEvent(new CustomEvent('change', { detail: { state, previous, label: stateLabels[state] } })); }
}
